









import { Component, Mixins, Prop } from "vue-property-decorator";

@Component
export default class AutomaticView extends Mixins() {
  @Prop()
  message: string;

  @Prop()
  process: () => Promise<void>;

  @Prop({ default: 320 })
  width: number;

  @Prop({ default: 100 })
  height: number;

  async created(): Promise<void> {
    window.moveTo(0, 0);
    window.resizeTo(this.width, this.height);
    await this.process();
    this.$closeWindow();
  }
}
